import { Box, type SxProps, type Theme } from "@mui/material";
import { useIntl } from "react-intl";

import { useAuthentication } from "../../hooks";
import { ReactComponent as PacknetIcon } from "../../assets/application-icons/packnet-icon.svg";
import { ReactComponent as SupportIcon } from "../../assets/application-icons/support-icon.svg";
import { ReactComponent as TenantManagementIcon } from "../../assets/application-icons/tenant-management-icon.svg";
import { ReactComponent as CompanyManagementIcon } from "../../assets/application-icons/company-management-icon.svg";

export interface ApplicationIconProps {
	readonly sx?: SxProps<Theme>;
}

export const ApplicationIcon = ({ sx }: ApplicationIconProps) => {
	const intl = useIntl();
	const { applicationName, applicationEnvironment } = useAuthentication();

	const getIcon = () => {
		if (applicationName === "TenantManagement") {
			return TenantManagementIcon;
		}

		if (applicationName === "Support") {
			return SupportIcon;
		}

		if (applicationName === "Company") {
			return CompanyManagementIcon;
		}

		return PacknetIcon;
	};

	return (
		<Box
			component={getIcon()}
			sx={{ filter: applicationEnvironment === "preprod" ? "grayscale(1)" : undefined, ...sx }}
			role="img"
			aria-label={intl.formatMessage({ id: "login.packsize-logo-alt", defaultMessage: "Packsize Logo" })}
		/>
	);
};
